import { ITabsState } from '../../types/tabs';
import { defaultTabs } from '../../reducers/tabs';
import { stringifyQueryParams } from '../../utils/location';
import { filterToQuery, IFilterQueryParams } from '../../store/filters/query';
import { IThunkActionCreator } from '../../types/redux';
import { updateTabs } from '../tabs';

export enum ELocationActionTypes {
  ChangeLocation = 'LOCATION/CHANGE_QUERY',
  ChangeHash = 'LOCATION/CHANGE_HASH',
}

export interface IChangeLocationAction {
  type: ELocationActionTypes.ChangeLocation;
  payload: {
    query: string;
    hash: string;
  };
}

export const changeLocation = (
  filterQuery: IFilterQueryParams,
  tabs: ITabsState,
  newHash?: string,
): IThunkActionCreator<void> => {
  return (dispatch, getState) => {
    const {
      location: { hash },
      tabs: stateTabs,
    } = getState();
    const { about, pikstandard, standard, children } = { ...stateTabs, ...tabs };
    const params = {
      ...filterQuery,
      about: about === defaultTabs.about ? undefined : about,
      pikstandard: pikstandard === defaultTabs.pikstandard ? undefined : pikstandard,
      standard: pikstandard !== 'standard' || standard === defaultTabs.standard ? undefined : standard,
      children: pikstandard !== 'children' || children === defaultTabs.children ? undefined : children,
    };

    const queryParams = stringifyQueryParams(params);
    const hashToApply = newHash || hash;

    const currentLocation = location.pathname + location.search + location.hash;
    const newLocation = `${location.pathname}${queryParams ? `?${queryParams}` : ''}${
      hashToApply ? `#${hashToApply}` : ''
    }`;

    if (newLocation !== currentLocation) {
      history.replaceState(history.state, document.title, newLocation);
    }

    dispatch({
      type: ELocationActionTypes.ChangeLocation,
      payload: {
        query: queryParams,
        hash: hashToApply,
      },
    });
  };
};

export const changeHash = (newHash: string): IThunkActionCreator<void> => {
  return (dispatch, getState) => {
    const {
      filter: { query },
      tabs,
    } = getState();
    const filterQuery = filterToQuery(query);

    dispatch(changeLocation(filterQuery, tabs, newHash));

    dispatch({
      type: ELocationActionTypes.ChangeHash,
      payload: {
        hash: newHash,
      },
    });
  };
};

export const changeTabs = (tabs: ITabsState): IThunkActionCreator<void> => {
  return (dispatch, getState) => {
    const {
      filter: { query },
    } = getState();
    const filterQuery = filterToQuery(query);

    dispatch(updateTabs(tabs));
    dispatch(changeLocation(filterQuery, tabs));
  };
};
